import { render } from "./NutricionView.vue?vue&type=template&id=42b9a4ac&ts=true"
import script from "./NutricionView.vue?vue&type=script&lang=ts"
export * from "./NutricionView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/femers/git/adminSanatorio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__